/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"

import Nav from "@components/nav"
import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import { useBrowserLayout } from "gpages/hooks/layout"
import { wxConfig, wxShare } from "@src/utils/wechat"
import classnames from "gpages/utils/classnames"
import logosImg from "@images/logos.png"
import logosSmImg from "@images/logos-sm.png"

const Layout = ({ children, location }) => {
  const { renderItem, isAppLayout, isNative } = useBrowserLayout({
    designRatio: 1.6,
    appWidth: 851,
  })

  const [prepared, setPrepared] = React.useState(false)

  useEffect(() => {
    setTimeout(() => {
      setPrepared(true)
    }, 2000)
  }, [])

  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])

  return (
    <AppContext.Provider value={{ renderItem, isAppLayout, isNative }}>
      <Seo />
      <Nav location={location} />
      <div
        className={classnames(styles.preparing, {
          [styles.prepared]: prepared,
        })}
      >
        <span>LOADING...</span>
      </div>
      <div className={styles.container}>
        <main>{children}</main>
      </div>
      <footer className={styles.footer}>
        <div>
          {renderItem(logosImg, logosSmImg)}
          {/* Copyright © 2009 - 2024 GAMECORES. All Rights Reserved */}
        </div>
      </footer>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
